import {BankTransferDetails} from "@/components/children/bankTransferDetails/scripts/types";
import type {Customer} from "@/components/customers/scripts";

const createEmptyBankTransferDetails = () => {
  const bankTransferDetails: BankTransferDetails = {
    id: 0,
    reference: undefined
  }

  return bankTransferDetails;
}

const resetBankTransferDetails = (originalObject: BankTransferDetails, changedObject: BankTransferDetails) => {
  changedObject.id = originalObject.id;
  changedObject.reference = originalObject.reference;
}

const bankTransferDetailsHaveChanges = (originalObject: BankTransferDetails, changedObject: BankTransferDetails) => {
  return originalObject.id !== changedObject.id
    || originalObject.reference !== changedObject.reference;
}

export {
  createEmptyBankTransferDetails,
  resetBankTransferDetails,
  bankTransferDetailsHaveChanges
}
